import * as React from 'react'
import styled from 'styled-components'

import { useFilters } from '~/hooks'
import Button from '~/truck/button'
import { getTextStyle } from '~/truck/utils'

export interface FilterButtonProps {
  onClick: () => void
}

const StyledButton = styled(Button.Ghost)`
  border-color: transparent;
  color: ${props => props.theme.palette.primary40};
  height: ${props => props.theme.spacing.cozy * 5}px;
  padding-left: ${props => props.theme.spacing.cozy * 1.5}px;
  padding-right: ${props => props.theme.spacing.cozy * 1.5}px;
  width: auto;
  ${getTextStyle('h5Semibold')}

  & > svg {
    fill: ${props => props.theme.palette.primary40};
    width: ${props => props.theme.spacing.cozy * 2.5}px;
    height: ${props => props.theme.spacing.cozy * 2.5}px;
  }

  &:hover,
  &:focus {
    background: ${props => props.theme.colors.white};
    border-color: ${props => props.theme.palette.primary40};
    color: ${props => props.theme.palette.primary40};

    & > svg {
      fill: ${props => props.theme.palette.primary40};
    }
  }
`

export function FilterButton(props: FilterButtonProps) {
  const { onClick } = props

  const { selectedTags } = useFilters()

  return <StyledButton onClick={onClick}>Filtrar ({selectedTags.length})</StyledButton>
}
